<div class="row align-items-baseline mb-2">
  <h5 class="col-auto">{{ 'Organizations' | translate }}</h5>
  <app-admin-organization-selector [(model)]="addItem" class="col" />
  <div class="col col-auto">
    <button class="btn btn-primary btn-sm" [disabled]="!addItem" (click)="add(addItem)">
      {{ 'Add' | translate }}
    </button>
  </div>
</div>

<div class="row">
  <div class="col">
    <ngx-datatable
      class="data-table table-responsive task-list-table"
      [rows]="data?.content"
      [columnMode]="'force'"
      [headerHeight]="50"
      [footerHeight]="50"
      [limit]="10"
      [rowHeight]="40"
    >
      <ngx-datatable-column name="name">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Nom' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          <a [routerLink]="['/',ADMIN_PREFIX,ORGANIZATIONS_ROUTE,row.code]">{{ row.name }}</a>
          <app-badge-organization [code]="row.code"></app-badge-organization>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="user">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Owner' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          {{ row.owner.email }}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [maxWidth]="80" name="actions" cellClass="actions">
        <ng-template let-column="column" ngx-datatable-header-template></ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          <i
            title="{{ 'facturer les sites non facturés de l\'organisation sur le contrat' | translate }}"
            (click)="linkSites(row)"
            class="pointer icofont icofont-web"
          ></i>
          <i
            title="{{ 'supprimer' | translate }}"
            (click)="remove(row)"
            style="color: #e74c3c"
            class="pointer icofont icofont-ui-delete"
          ></i>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template>
          <app-table-pager [data]="data" [page]="page" (changePage)="changePage($event)" />
        </ng-template>
      </ngx-datatable-footer>
    </ngx-datatable>
  </div>
</div>
